import React from "react";
import { UserPlus, UsersIcon } from "lucide-react";
import { Button } from "@/shared/ui/button"
import { useTranslation } from "react-i18next";

export const AddMemberButton = ({ showNewUserForm, setShowNewUserForm }) => {
  const { t } = useTranslation();
  return (
    <Button
      onClick={() => setShowNewUserForm(!showNewUserForm)}
      className="font-SuisseIntlLight text-sm w-full sm:w-auto"
    >
      {!!showNewUserForm ? (
        <div className="flex gap-1 items-center">
          <UsersIcon size={18} />
          <span>{t("profile.members.allMembers")}</span>
        </div>
      ) : (
        <div className="flex gap-1 items-center">
          <UserPlus size={18} />
          <span>{t("profile.members.addMember")}</span>
        </div>
      )}
    </Button>
  );
};
